import script from "./index1.vue?vue&type=script&setup=true&lang=js"
export * from "./index1.vue?vue&type=script&setup=true&lang=js"

import "./index1.vue?vue&type=style&index=0&id=0f038492&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f038492"]])

export default __exports__